<script setup lang="ts">
import type { NuxtError } from "#app";

defineProps<{
  error?: NuxtError;
}>();
const { t } = useI18n();
navigateTo("/");
</script>

<template>
  <div>
    <h1>{{ error?.statusCode }}</h1>
    <NuxtLink to="/">{{ t("common.go_back_home") }}</NuxtLink>
  </div>
</template>
